/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { ReactNode, useEffect, useState, PropsWithChildren } from "react";

export const NoSSR = ({ children }: PropsWithChildren): ReactNode => {
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	return isClient ? children : <></>;
};
